import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './TransportInventoryTable.html?raw';

import _WidgetBaseSP from 'more/_WidgetBaseSP';
import { BookedForTypes, InventoryLoadData, TravelBookingLoadData } from "../../../../TravelBookingListTypes";
import { VAM2types } from "../../../../../../_loadingHelpers/VAMv2Types";
import StaticTable from '../../../../../../../moreCore/UI/StaticTable/StaticTable';
import EntityStore from '../../../../../../../moreCore/Tools/EntityStore';
import lang from 'dojo/_base/lang';

class TransportInventoryTable extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private entity: TravelBookingLoadData;
    private project: VAM2types.EvProjectEntity_Extended;

    private bookedForType: BookedForTypes;

    private tableContainer: HTMLDivElement;
    private table: MdsLax<InstanceType<typeof StaticTable>>;

    private store: MdsLax<InstanceType<typeof EntityStore<InventoryLoadData>>>; 


    private tableRowLayout: StaticTable.RowConfig = {
        colNamesInternal: ["inventoryNumber", "inventoryDescription"],
        "attributes": ["ref_vt_inventory.inventory_number", "ref_vt_inventory.description"],
        "headings": [(this as any).translate("TransportBookingForm_Heading_InventoryNumber"), (this as any).translate("TransportBookingForm_Heading_InventoryDescription")],
        bgColors: [null, null],
    }

    private tableLayout: StaticTable.Layout = {
        name: "layout",
        label: (this as any).translate("TravelBookingForm_Heading_BookedFor"),
        rows: [(this as any).tableRowLayout],
        layoutStyle: "auto"
    }

    isStoreEmpty(): boolean {
        return this.store.getCurrentCompleteList().length <= 0;
    }

    hasEntities(): boolean {
        let completeList = this.store.getCurrentCompleteList();
        return completeList.length > 0;
    }

    getData(): EntityStoreData<InventoryLoadData> {
        return this.store.getDiffData();
    }

    setEntity(entity: TravelBookingLoadData) {
        this.entity = entity;
        this.store.setup(this.entity.EL_ht_inventory_transport_transport_booking);
        this.table.setupFromStore(this.store);
    }

    createTable(project: VAM2types.EvProjectEntity_Extended, bookedForType: BookedForTypes) {
        this.project = project;
        this.bookedForType = bookedForType;

        this.table = new StaticTable();

        this.table.addLayout(this.tableLayout);
        this.table.setCyAttribute("TravelBookingTransportInventoryTable");

        this.UiModder.domConstruct.place(this.table.domNode, this.tableContainer);

        this.table.setupFromStore(this.store);
    }

    private _onStoreChange(): void {
        this.emit("change", this.store.isDirty());
    }

    deactivateRowClick(): void {
        //Do Nothing
    }

    activateRowClick(): void {
        //DO nothing
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.store = new EntityStore<InventoryLoadData>();

        this.store.on("change", lang.hitch(this, this._onStoreChange));
        this.store.on("delete", lang.hitch(this, this._onStoreChange));
        this.store.on("added", lang.hitch(this, this._onStoreChange));
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(TransportInventoryTable);